export { default as ProductCard, LAST_TILE_MEDIA } from "./ProductCard";
